#import "../fragments/scheduler-meeting-chat-fragment.graphql"

query GetSchedulerMeetingsChat($sort: MeetingSortOrder) {
    meetings(sort: $sort) {
        ...SchedulerMeetingChatFragment
    }
}
